import axios from "axios";
import { GET_IMPORTED_PROJECT_CONFIGURATION_URL } from "@/utils/constants/constants.js";

export default {
  methods: {
    async load_imported_project_configuration() {
      if (!this.project_id) return;
      this.imported_configuration_loading = true;
      try {
        const response = await axios.get(GET_IMPORTED_PROJECT_CONFIGURATION_URL, {
          headers: this.headers,
          params: { project_id: this.project_id },
        });
        const payload = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
        this.imported_configuration_forms = payload?.data?.forms || [];
        this.imported_configuration_templates = payload?.data?.templates || [];
      } catch {
        this.imported_configuration_forms = [];
        this.imported_configuration_templates = [];
      } finally {
        this.imported_configuration_loading = false;
      }
    },
  },
};
